import { twMerge } from 'tailwind-merge';

interface TextProps {
  text: string;
  className?: string;
}

export const Text = ({ text, className }: TextProps) => {
  return (
    <div className={twMerge('text-md text-gray-600', className)}>{text}</div>
  );
};
